module.exports = __webpack_public_path__ + "img/satyr_small.cedd9a37.png";